<script>
  import { getContext, setContext } from "svelte";
  import { cloneDeep } from "lodash";

  export let entities = null;

  let trackingContext = getContext("trackingContext");

  if (!trackingContext) {
    trackingContext = {
      entities: [],
    };
  }

  let clonedTrackingContext = cloneDeep(trackingContext);

  if (Array.isArray(entities)) {
    clonedTrackingContext.entities = [...entities, ...clonedTrackingContext.entities];
  } else if (entities) {
    clonedTrackingContext.entities.unshift(entities);
  }

  Object.freeze(clonedTrackingContext);

  setContext("trackingContext", clonedTrackingContext);
  trackingContext = clonedTrackingContext;

</script>

<slot {trackingContext} />
